module.exports = __webpack_public_path__ + "static/media/report.017520b1.svg";